var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoCamAlert(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15502_17098",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 72,
    height: 72
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15502_17098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3248 60.4492C35.6033 60.4492 34.997 60.2024 34.506 59.7089C34.015 59.2154 33.7695 58.6062 33.7695 57.8812C33.7695 57.1562 34.015 56.5512 34.506 56.0662C34.997 55.5817 35.6033 55.3394 36.3248 55.3394H49.3388V16.6619H10.6613L10.6613 31.1559C10.6613 31.8889 10.4145 32.5009 9.92101 32.9919C9.42751 33.4829 8.81826 33.7284 8.09326 33.7284C7.36826 33.7284 6.76351 33.4829 6.27901 32.9919C5.79401 32.5009 5.55151 31.8889 5.55151 31.1559V16.6619C5.55151 15.2769 6.05826 14.0762 7.07176 13.0597C8.08476 12.0427 9.28126 11.5342 10.6613 11.5342H49.3388C50.7238 11.5342 51.9245 12.0427 52.941 13.0597C53.958 14.0762 54.4665 15.2769 54.4665 16.6619V32.6257L64.2473 22.8449C64.6333 22.4469 65.0995 22.3507 65.646 22.5562C66.193 22.7617 66.4665 23.1437 66.4665 23.7022V48.2992C66.4665 48.8577 66.193 49.2397 65.646 49.4452C65.0995 49.6507 64.6333 49.5544 64.2473 49.1564L54.4665 39.3757V55.3394C54.4665 56.7194 53.958 57.9159 52.941 58.9289C51.9245 59.9424 50.7238 60.4492 49.3388 60.4492H36.3248Z",
    fill: "#617A85"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 67C9.754 67 6.5675 65.6865 3.9405 63.0595C1.3135 60.4325 0 57.246 0 53.5C0 49.754 1.3135 46.5675 3.9405 43.9405C6.5675 41.3135 9.754 40 13.5 40C17.246 40 20.4325 41.3135 23.0595 43.9405C25.6865 46.5675 27 49.754 27 53.5C27 57.246 25.6865 60.4325 23.0595 63.0595C20.4325 65.6865 17.246 67 13.5 67ZM12.1729 62.3271H14.8264V54.8271H22.3264V52.1736H14.8264V44.6736H12.1729V52.1736H4.67285V54.8271H12.1729V62.3271Z",
    fill: "#FCBE1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCamAlert);
export default __webpack_public_path__ + "static/media/videoCamAlert.ec289560130dea0db9cf9419d9eed544.svg";
export { ForwardRef as ReactComponent };